import React, {Component} from 'react';
import {queryPayableStatistics} from '@api/incubator/payable';
import ComponentBill from './ComponentBill';
import SelectIncubator from '../SelectIncubator';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      incuUuid: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getPayableStatistics();
  }

  componentWillReceiveProps(nextProps) {}

  getPayableStatistics = (uuid = '') => {
    queryPayableStatistics({
      incubatorUuid: uuid,
    }).then(res => {});
  };

  handleIncuChange = e => {
    this.getPayableStatistics(e);
    this.setState({
      incuUuid: e,
    });
  };

  render() {
    const { incuUuid } = this.state;
    return (
      <div>
        <SelectIncubator onChange={this.handleIncuChange} />
        <ComponentBill {...this.props} incuUuid={incuUuid} />
      </div>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/Index.js